function NotFoundPage() {
  window.open(
    `${process.env.REACT_APP_DEVCENTER_URL}${window.location.pathname}`,
    "_self"
  );

  return null;
}

export default NotFoundPage;
